import React from "react";
import { ThunderboltOutlined } from "@ant-design/icons";

const clampPercentage = (value) => {
  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return 0;
  }

  return Math.min(100, Math.max(0, Math.round(numericValue)));
};

const CreditUsagePanel = ({
  title = "Credit Usage",
  remainingCredits = 0,
  totalCredits = 0,
  onBuyMore,
  buyMoreDisabled = false,
}) => {
  const usedCredits = Math.max(0, totalCredits - remainingCredits);
  const usedPercentage = totalCredits > 0 ? clampPercentage((usedCredits / totalCredits) * 100) : 0;

  return (
    <div className="transactionHistory-usageCard">
      <div className="transactionHistory-usageHead">
        <div className="transactionHistory-sectionLabel">{title}</div>
        <button className="transactionHistory-buyBtn" type="button" onClick={onBuyMore} disabled={buyMoreDisabled}>
          <ThunderboltOutlined />
          <span>Buy More</span>
        </button>
      </div>

      <div className="transactionHistory-usageSummary">
        <div className="transactionHistory-usageCount">{remainingCredits}</div>
        <div className="transactionHistory-usageSubtitle">Credits Remaining</div>
      </div>

      <div className="transactionHistory-usageTrack">
        <div
          className="transactionHistory-usageFill"
          style={{ width: `${usedPercentage}%` }}
        />
      </div>

      <div className="transactionHistory-usageFooter">
        <span>{usedPercentage}% used</span>
        <span>
          {usedCredits} / {totalCredits}
        </span>
      </div>
    </div>
  );
};

export default CreditUsagePanel;
